import Account from "./account";
import Modal from "./modal";
import Screensize from "./screensize";

export default {
    modules: {
        account: Account,
        modal: Modal,
        screensize: Screensize,
    }
};